module.exports = __webpack_public_path__ + "img/Oval.c776b473.svg";